import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import api from './service/api'
import i18n from './locales'
import './permission'

import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn');

import * as filters from './util/filter.js' // global filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// import './util/permission'

import Antd from 'ant-design-vue'
// import 'ant-design-vue/dist/antd.css'
import 'ant-design-vue/dist/antd.less'

Vue.use(Antd)

Vue.config.productionTip = false;
Vue.prototype.$api = api

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
